import {
  FeatureAppTrackingManager,
  getDefaultTrackingEvent,
  TrackingContent,
} from '../services/use-tracking-manager';

export const onVWBasicLinkClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentId: string,
  content: TrackingContent,
) => {
  let customEvent = getDefaultTrackingEvent();
  customEvent.eventInfo = { ...customEvent.eventInfo, contentId: contentId };
  customEvent.content = { ...customEvent.content, ...content };
  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VWBasic_Link_Click',
      customEvent,
    );
};

export const onVWBasicTwitterLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentId: string,
  content: TrackingContent,
) => {
  let customEvent = getDefaultTrackingEvent();
  customEvent.eventInfo = { ...customEvent.eventInfo, contentId: contentId };
  customEvent.content = { ...customEvent.content, ...content };

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VWBasic_Twitter_Load',
      customEvent,
    );
};
